/*
 * Copyright (c) 2020.
 *
 * Robert Siennicki (rs@bananahouse.pl)
 * http://bananahouse.pl
 */

$(function(){
    function initHowWork() {
        const $section = $('.section-how-work');
        if(!$section.length){
            return;
        }

        let $packagesContainer = $section.find('.packages-container');

        $(document).on('param:change param:init', function (e, formName, name, value, state) {
            if(name=='finance_type' && state === true){
                $section.find('.section-nav .nav-link[data-finance="'+value+'"]').click();
            }
        });

        $(document).on('lead:change lead:init', function (e, name, value, state) {
            if(name=='finance_type' && (typeof state==='undefined' || state === true)){
                $section.find('.section-nav .nav-link[data-finance="'+value+'"]').click();
            }
        });

        $section.find('.section-nav .nav-link').on('shown.bs.tab', function (e) {
            $packagesContainer.show();

            if($(e.target).data('finance')!='rent'){
                $packagesContainer.hide();
            }
        });
    }

    initHowWork();
});
